// Frame Components
import React from "react";

export default ({ title, wrapClass }) => (
  <div className={`page-header ${wrapClass}`}>
    <h1 className="page-title">{title}</h1>
  </div>
);
